import { SpherePlatformAppPaths } from '@sphere/platform';

export const PATHS: SpherePlatformAppPaths = {
    ['WORKSPACES_ROOT']: ''
};
